import {useAuth} from '../../../../core/usecases/useAuth';
import {cn} from '../../../../lib/classname';
import {useMediaQuery} from '../../../../shared/services/useMediaQuery';
import {LoginNavigationForLimitedPost} from '../Container/Presenter/LoginNavigationForLimitedPost';
import {RegistrationNavigationBottom} from '../Container/Presenter/RegistrationNavigationBottom';
import {RegistrationNavigationTop} from '../Container/Presenter/RegistrationNavigationTop';
import {ShareButtonsForPostContent} from '../Container/Presenter/ShareButtonsForPostContent';
import {PostContent} from './Content';

type Props = {
  parsedContent: string;
  isSponsored: boolean;
  title: string;
  currentUrl: string;
  isRequiredLogin: boolean;
  className?: string;
};

export const PostBody: React.FC<Props> = ({
  parsedContent,
  isSponsored,
  title,
  currentUrl,
  isRequiredLogin,
  className,
}: Props) => {
  const {isSignedIn} = useAuth();
  const {isPC} = useMediaQuery();

  return (
    <div
      className={cn(
        'w-full bg-white rounded-t-4 rounded-b-16 overflow-hidden',
        className,
      )}
    >
      {!isSignedIn && <RegistrationNavigationTop />}
      <PostContent parsedContent={parsedContent} className="px-24" />
      {!isSignedIn && isRequiredLogin && <LoginNavigationForLimitedPost />}
      {!isSignedIn && !isSponsored && !isRequiredLogin && (
        <RegistrationNavigationBottom />
      )}
      {!isPC && (
        <>
          <p className="bg-white px-16">この記事を友達に教える</p>
          <ShareButtonsForPostContent title={title} currentUrl={currentUrl} />
        </>
      )}
    </div>
  );
};
